export default __webpack_public_path__ + "static/media/halfee.388df4d1.png";